<template>
  <div>
    <el-popover
        :popper-class="msgPopperClass"
        trigger="focus">
      <div class="is-error-msg">
        {{ errorMsg }}
      </div>
      <el-input
          slot="reference"
          ref="input"
          :class="{'is-error': errorMsg }"
          :value="setValue"
          :name="name"
          :type="type"
          :maxlength="maxlength"
          :minlength="minlength"
          :placeholder="placeholder"
          :clearable="clearable"
          :disabled="disabled"
          :size="size"
          :prefix-icon="prefixIcon"
          :suffix-icon="suffixIcon"
          :rows="rows"
          :autosize="autosize"
          :auto-complete="autoComplete"
          :readonly="readonly"
          :resize="resize"
          :autofocus="autofocus"
          :show-password="showPassword"
          :form="form"
          :label="label"
          :tabindex="tabindex"
          @input="updateInputValue"
          @focus="onFocus"
          @blur="onBlur">
        <template slot="prepend"><slot name="prepend" /></template>
        <template slot="prefix"><slot name="prefix" /></template>
        <template slot="suffix"><slot name="suffix" /></template>
        <template slot="append"><slot name="append" /></template>
      </el-input>
    </el-popover>
    <div v-show="!popoverErrorMsg && errorMsg"
        class="is-error-msg">
      {{ errorMsg }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ValidCore from '@/components/atoms/BaseValidCore'

export default {
  name: 'BaseValidInput',
  mixins: [ValidCore],
  props: {
    //  Input Attributes
    size: {
      type: String,
      default: undefined,
      validator: function (value) {
        return ['medium', 'small', 'mini'].indexOf(value) !== -1
      }
    },
    resize: {
      type: String,
      default: undefined,
      validator: function (value) {
        return ['none', 'both', 'horizontal', 'vertical'].indexOf(value) !== -1
      }
    },
    form: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    autosize: { type: [Boolean, Object], default: false },
    autoComplete: {
      type: String,
      default: 'off',
      validator: function (value) {
        return ['on', 'off', 'new-password'].indexOf(value) !== -1
      }
    },
    suffixIcon: { type: String, default: undefined },
    prefixIcon: { type: String, default: undefined },
    label: { type: String, default: undefined },
    clearable: { type: Boolean, default: false },
    tabindex: { type: String, default: undefined },
    rows: { type: Number, default: 1 },
    placeholder: { type: String, default: undefined },
    maxlength: { type: Number, default: undefined },
    minlength: { type: Number, default: undefined },
    autofocus: { type: Boolean, default: false },
    showPassword: { type: Boolean, default: false }
  },
  data () {
    return {
      whenFocused: null
    }
  },
  computed: {
    setValue () {
      return this.inputValue != null ? this.inputValue.toString() : ''
    }
  },
  methods: {
    onFocus (event) {
      this.whenFocused = _.cloneDeep(this.inputValue)
      this.$emit('focus', event)
    },
    onBlur (event) {
      this.$emit('blur', event, this.whenFocused, this.inputValue)
    },
    // 親からインプット要素をフォーカスするために使われる
    focus: function () {
      this.$refs.input.focus()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/BaseValidInput.vue